import { render, staticRenderFns } from "./ConfiguratorQuestionsTab.vue?vue&type=template&id=2a3f28a2&"
import script from "./ConfiguratorQuestionsTab.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorQuestionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports